export default __webpack_public_path__ + "static/social-default-image-a491aaed17e294adcd893961ea7a4ac4.png";